import { runtimeConfig } from '../services/RuntimeConfig';

export class AdminTemplateService {

  static getTemplateParameters(templateKind?: string) {

    const baseUrl = runtimeConfig.redirectUri;
    const courseUrl = `${baseUrl}/course/2024_SU_1_SCN`;

    switch (templateKind) {
      case 'page':
        return {
          'baseUrl': {
            sample: baseUrl,
            description: 'The base URL of the application'
          },
        };

      case 'email':
        return {
          'baseUrl': {
            sample: baseUrl,
            description: 'The base URL of the application'
          },
          'Name': {
            sample: 'Leo Vector',
            description: 'The user the email is being sent to'
          },
          'Email': {
            sample: 'leo.vector@urbandevlab.eu',
            description: 'The EIT UM email address'
          },
          'CourseProvider': {
            sample: 'Some University',
            description: 'The course provider name'
          },
          'CourseName': {
            sample: 'Some Course',
            description: 'The name of the related course'
          },
          'LinkCourseName': {
            sample: `<a href='${courseUrl}' target='_blank'>Some Course</a>`,
            description: 'A link to the related course'
          },
          'CourseId': {
            sample: '2024_SU_1_SCN',
            description: 'The ID of the related course (folder name)'
          },
          'LinkCourseId': {
            sample: `<a href='${courseUrl}' target='_blank'>2024_SU_1_SCN</a>`,
            description: 'A link to the related course using the course ID'
          },
          'Step': {
            sample: 'Step X',
            description: 'The current process step name'
          },
          'LinkStep': {
            sample: `<a href='${courseUrl}/STEPX/view' target='_blank'>Step X</a>`,
            description: 'A link to the current process step'
          },
          'NextStep': {
            sample: 'Step Y',
            description: 'The next process step name'
          },
        }

        default:
        return {
        }
    }
  }

}